// IMAGE SECTIONS
import art from '../Images/HomePage/Sections/artSection.webp';
import books from '../Images/HomePage/Sections/booksSection.webp';
import eBooks from '../Images/HomePage/Sections/eBooksSection.webp';
import dictionary from '../Images/HomePage/Sections/dictionarySection.webp';
import thesaurus from '../Images/HomePage/Sections/thesaurusSection.webp';
import job from '../Images/HomePage/Sections/job.png';
import articles from '../Images/HomePage/Sections/articlesSection.webp';
import media from '../Images/HomePage/Sections/media.png';
import news from '../Images/HomePage/Sections/newsSection.webp';
import patents from '../Images/HomePage/Sections/patentsSection.webp';
import interestingLinks from '../Images/HomePage/Sections/interestingLinksSection.webp';
import softSkillsSection from '../Images/HomePage/Sections/softSkillsSection.webp';
import iaSection from '../Images/HomePage/Sections/iaSection.webp';
// ICONS SECTIONS
import artIcon from '../Images/Login/Modal/artIcon.svg';
import articlesIcon from '../Images/Login/Modal/articlesIcon.svg';
import dictionaryIcon from '../Images/Login/Modal/dictionaryIcon.svg';
import thesaurusIcon from '../Images/Login/Modal/thesaurusIcon.svg';
import patentsIcon from '../Images/Login/Modal/patentsIcon.svg';
import newsIcon from '../Images/Login/Modal/newsIcon.svg';
import jobsIcon from '../Images/Login/Modal/jobsIcon.svg';
import interestingLinksIcon from '../Images/Login/Modal/interestingLinksIcon.svg';
import americanLifeIcon from '../Images/Login/Modal/americanLifeIcon.svg';
import videoLibraryIcon from '../Images/Login/Modal/interestingLinksIcon.svg';
import instructionalVideosIcon from '../Images/Login/Modal/instructionalVideosIcon.svg';
import helpIcon from '../Images/Login/Modal/helpIcon.svg';
import ebookIcon from '../Images/Login/Modal/ebookIcon.svg';
import iaIcon from '../Images/Login/Modal/iaIcon.png';
import galeIcon from '../Images/Login/Modal/galeIcon.png';
import heartIcon from '../Images/Login/Modal/heartIcon.svg';
import { isCosmetology } from '../utils/isCosmetology';

// Section Images

import DictionarySectionImg from '../Images/HomePage/SectionsV2/dictionary.png';
// import BooksSectionImg from '../Images/HomePage/SectionsV2/books.png';
import MediaSectionImg from '../Images/HomePage/SectionsV2/media.png';
import ThesaurusSectionImg from '../Images/HomePage/SectionsV2/thesaurus.png';
import ArticlesSectionImg from '../Images/HomePage/SectionsV3/articles.png';
import IASectionImg from '../Images/HomePage/SectionsV3/aquino_ai.png';
import CarrerDevelopmentSectionImg from '../Images/HomePage/SectionsV3/carrer_development.png';
import PatentsSectionImg from '../Images/HomePage/SectionsV3/patents.png';
import GaleSectionImg from '../Images/HomePage/SectionsV3/gale.png';
import NewsSectionImg from '../Images/HomePage/SectionsV3/news.png';
import InterestingLinksSectionImg from '../Images/HomePage/SectionsV3/interesting_links.png';
import EbooksSectionImg from '../Images/HomePage/SectionsV3/ebooks.png';
import JobHunterSectionImg from '../Images/HomePage/SectionsV3/jobs.png';
import TutorialsSectionImg from '../Images/HomePage/SectionsV3/tutorials.png';

// Icons section
export const getSectionsWithoutNavbar = () => {
	return [
		'',
		'login',
		'signup',
		'recover',
		'ebooks',
		'gale',
		'ai',
		'login-with-wordpress',
	];
};

export const sectionsToRemoveIfNotLoggedIn = ['my-favorites'];
// Articulos, diccionario, tesauro, patente, noticias, books, aquina ia y artes
export const sectionsToRemoveInCosmetology = [
	'articles',
	'dictionary',
	'thesaurus',
	'patents',
	'news',
	'books',
	'ai',
	'art',
];

// Return the list of section that should be displayed if the user is not logged in
export const getSectionsNoAuth = (sectionList) => {
	const sections = sectionList.filter(
		(section) => !sectionsToRemoveIfNotLoggedIn.includes(section.route),
	);

	return sections;
};

export const getCosmetologySections = (sectionList) => {
	const sections = sectionList.filter(
		(section) => !sectionsToRemoveInCosmetology.includes(section.route),
	);

	return sections;
};

export const getSectionsInstitutions = (institutionCode, ebooks) => {
	let sections = [
		{
			type: 'metasearcher',
			data: [
				{
					title: 'Articles',
					url: articles,
					route: 'articles',
					description: '16k+ library results',
					icon: articlesIcon,
					type: 'metasearcher',
					bgImage: ArticlesSectionImg,
				},
				{
					title: 'Dictionary',
					url: dictionary,
					route: 'dictionary',
					description: 'More than 20k words from the dictionary',
					icon: dictionaryIcon,
					type: 'metasearcher',
					bgImage: DictionarySectionImg,
				},
				{
					title: 'Thesaurus',
					url: thesaurus,
					route: 'thesaurus',
					description: 'Thesaurus dictionary',
					icon: thesaurusIcon,
					type: 'metasearcher',
					bgImage: ThesaurusSectionImg,
				},
				{
					title: 'Patents',
					url: patents,
					route: 'patents',
					description: 'More than 20k Patent results',
					icon: patentsIcon,
					type: 'metasearcher',
					bgImage: PatentsSectionImg,
				},
				{
					title: 'News',
					url: news,
					route: 'news',
					description: 'Recent and relevant global news',
					icon: newsIcon,
					type: 'metasearcher',
					bgImage: NewsSectionImg,
				},
				{
					title: 'Media',
					url: media,
					route: 'media',
					description: 'Rich instructional videos',
					icon: instructionalVideosIcon,
					type: 'metasearcher',
					bgImage: MediaSectionImg,
				},
			],
		},
		{
			type: 'independient',
			data: [
				{
					title: 'Job Hunter',
					url: job,
					route: 'jobs',
					description: 'More than 2k job offers',
					icon: jobsIcon,
					type: 'independient',
					bgImage: JobHunterSectionImg,
				},
				{
					title: 'Interesting Resources',
					url: interestingLinks,
					route: 'interesting-links',
					description: 'Interesting Resources',
					icon: interestingLinksIcon,
					type: 'independient',
					bgImage: InterestingLinksSectionImg,
				},
				{
					title: 'Career Development',
					url: softSkillsSection,
					route: 'american-life',
					description: 'Learn about Soft Skills and American life',
					icon: americanLifeIcon,
					type: 'independient',
					bgImage: CarrerDevelopmentSectionImg,
				},
				{
					title: 'Tutorials',
					url: '',
					route: 'tutorials',
					description: 'Turotials',
					icon: interestingLinksIcon,
					type: 'independient',
					bgImage: TutorialsSectionImg,
				},
				{
					title: 'My favorites',
					url: '',
					route: 'my-favorites',
					childPage: 'favorites',
					description: 'Find your favorite content',
					icon: heartIcon,
					type: 'independient',
				},
				{
					title: 'Help',
					url: '',
					route: 'help',
					description: 'Help',
					icon: helpIcon,
					type: 'independient',
				},
				{
					title: 'Search',
					url: '',
					route: 'search',
					description: 'Search',
					icon: '',
					type: 'none',
				},
			],
		},
	];

	institutionCode !== 'UTH' &&
		sections[0].data.push({
			title: institutionCode === 'ST' ? 'Digital Books' : 'EBooks',
			url: books,
			route: 'books',
			description: '16k+ books results',
			icon: articlesIcon,
			type: 'metasearcher',
			bgImage: EbooksSectionImg,
		});

	ebooks &&
		sections[0].data.push({
			title:
				institutionCode !== 'ST'
					? 'Spanish Resources'
					: 'Supplementary Resources',
			url: eBooks,
			route: isCosmetology(institutionCode)
				? 'https://network-library.digital-content.890m.com' // Librería7-24 Para cosmetologia (Nouvelle lib)
				: 'ebooks',
			description:
				institutionCode !== 'ST'
					? 'Spanish Resources'
					: 'Supplementary Resources',
			icon: ebookIcon,
			type: 'other',
			target: isCosmetology(institutionCode) ? '_blank' : '_self',
			bgImage: EbooksSectionImg,
		});

	const galeSection =
		institutionCode !== 'AES'
			? {
					title: 'GALE Resources',
					url: '',
					route: 'gale',
					description: 'GALE Resources',
					icon: galeIcon,
					type: 'other',
					bgImage: GaleSectionImg,
				}
			: null;

	sections[0].data.push(...(galeSection ? [galeSection] : []), {
		title: 'Aquino AI',
		url: iaSection,
		route: 'ai',
		description: 'Aquino AI',
		icon: iaIcon,
		type: 'other',
		bgImage: IASectionImg,
	});

	(institutionCode === 'MTA' ||
		institutionCode === 'DEMO' ||
		institutionCode === 'LIBRARIAN') &&
		sections[1].data.unshift({
			title: 'Art',
			url: art,
			route: 'art',
			description: 'More than 10k art stories',
			icon: artIcon,
			type: 'independient',
			bgImage: art,
		});

	institutionCode === 'MACKENZIE' &&
		sections[1].data.unshift({
			title: 'Library Video',
			url: art,
			route: 'video-library',
			description: 'Library videos',
			icon: videoLibraryIcon,
			type: 'independient',
			bgImage: art,
		});

	return sections;
};
